import { get } from "../../utils/object-helpers";

$ {
    const countries = get(input, "maxView.countryGroup.entries", []);
    const zipCodePlaceholder = get(input, "maxView.zipcode.accessibilityText", "");
    const buttonText = get(input, "maxView.goButton.label.textSpans.0.text", "");
    const btnTracking = get(input, "maxView.goButton.label.trackingList", "");
    const countryLabel = get(input, "maxView.countryGroup.label.accessibilityText", "");
}

<if(countries.length)>
    <ebay-button aria-expanded="false" class=`str-ship-location__button no-border str-ship-location__label--${state.showClass}`
        variant="fake-link" on-click("toggleLocationPopup") data-testid="ship-to-button">
        ${state.miniLabel}
        <span class="str-ship-location__label--selected">${state.currentZip}</span>
        <ebay-chevron-down-16-icon/>
    </ebay-button>
    <div class=`str-ship-location-selection str-ship-location-selection__${state.showClass}`>
        <fieldset>
            <legend class="str-ship-location-selection__header">${state.formHeader}</legend>
            <form class="str-ship-location-selection__form" on-submit("validateZip")  data-testid="location-form">
                <ebay-select key="country" on-change("selectCountry") floatingLabel=countryLabel>
                    <for|country| of=countries>
                        <@option value=country.paramValue text=country.label.textSpans[0].text selected=(state.selected===country.paramValue)/>
                    </for>
                </ebay-select>
                <div class="str-ship-location-selection__form--zipcode">
                    <ebay-textbox value=state.zipCodeValue placeholder=zipCodePlaceholder
                                aria-label=zipCodePlaceholder key="zipcode"
                                aria-invalid="false" disabled=state.zipCodeDisable
                                floatingLabel=zipCodePlaceholder
                    />
                </div>
                <input class="str-ship-location-selection__form--input" type="submit" value=buttonText data-track=btnTracking/>
            </form>
            <div id="str-ship-location-selection__error" class="str-ship-location-selection__error">${state.errorMsg}</div>
        </fieldset>
    </div>
    <div class=state.maskClass on-click("maskClick") data-testid="location-mask"></div>
</if>
